module.exports = __webpack_public_path__ + "static/media/features-management.581a19e5.png";